import { render, staticRenderFns } from "./movie-detail2.vue?vue&type=template&id=6e10f40d&scoped=true"
import script from "./movie-detail2.vue?vue&type=script&lang=js"
export * from "./movie-detail2.vue?vue&type=script&lang=js"
import style0 from "./movie-detail2.vue?vue&type=style&index=0&id=6e10f40d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10f40d",
  null
  
)

export default component.exports